export default __webpack_public_path__ + "static/birds-9792fd707e8c5515d4b8968799d50e55.png";